import { render } from "./TextItems.vue?vue&type=template&id=d811f15e&scoped=true"
import script from "./TextItems.vue?vue&type=script&lang=js"
export * from "./TextItems.vue?vue&type=script&lang=js"

import "./TextItems.vue?vue&type=style&index=0&id=d811f15e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d811f15e"],['__file',"src/containers/popup/components/TextItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d811f15e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d811f15e', __exports__)) {
    api.reload('d811f15e', __exports__)
  }
  
  module.hot.accept("./TextItems.vue?vue&type=template&id=d811f15e&scoped=true", () => {
    api.rerender('d811f15e', render)
  })

}


export default __exports__